<template>
  <div class="w-full mx-auto p-6 bg-white shadow rounded">
    <label class="block font-semibold mb-1">Title *</label>
    <input
      v-model="form.title"
      type="text"
      placeholder="Enter Title"
      class="w-full border rounded px-3 py-2 mb-4 focus:ring focus:ring-blue-400 focus:border-blue-400"
    />

    <label class="block font-semibold mb-1">Short Description *</label>
    <textarea
      v-model="form.short_desc"
      placeholder="Enter short description"
      class="w-full border rounded px-3 py-2 mb-4 focus:ring focus:ring-blue-400 focus:border-blue-400"
    ></textarea>

    <div class="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
      <div class="lg:col-span-2">
        <label class="block font-semibold mb-1">Banner *</label>
        <div
          class="w-full border-2 border-dashed rounded relative mb-2 cursor-pointer hover:border-blue-400 transition h-[316px] overflow-hidden"
        >
          <input
            type="file"
            class="hidden"
            ref="fileInput"
            @change="uploadBanner"
            accept=".png, .jpeg, .jpg"
          />
          <div
            @click="$refs.fileInput.click()"
            class="w-full h-full"
          >
            <div v-if="!form.banner" class="flex flex-col items-center justify-center h-full text-gray-500">
              <span class="text-4xl block mb-2">+</span>
              Click to upload or drag and drop
            </div>
            <div v-else class="relative w-full h-full">
              <img
                :src="form.banner"
                class="w-full h-full object-cover object-top"
                alt="Banner Preview"
              />
              <div class="absolute bottom-0 w-full bg-black bg-opacity-50 text-white text-xs py-2 text-center">
                Click to change banner
              </div>
            </div>
          </div>
        </div>

        <div class="flex space-x-4 mb-4 items-center mt-4">
          <div>
            <label class="block font-semibold mb-1">Status</label>
            <div class="flex space-x-2">
              <span
                @click="form.status = 'Active'"
                :class="
                  form.status === 'Active'
                    ? 'bg-green-500 text-white'
                    : 'bg-gray-200 text-gray-700'
                "
                class="px-4 py-1 rounded-full text-sm cursor-pointer transition"
              >
                Active
              </span>
              <span
                @click="form.status = 'Inactive'"
                :class="
                  form.status === 'Inactive'
                    ? 'bg-red-500 text-white'
                    : 'bg-gray-200 text-gray-700'
                "
                class="px-4 py-1 rounded-full text-sm cursor-pointer transition"
              >
                Inactive
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="lg:col-span-1 space-y-4">
        <div>
          <label class="block font-semibold mb-1">Meta Keyword *</label>
          <input
            v-model="form.meta_keyword"
            class="w-full border rounded px-3 py-2"
          />
        </div>
        <div>
          <label class="block font-semibold mb-1">Meta Description *</label>
          <textarea
            v-model="form.meta_desc"
            rows="4"
            class="w-full border rounded px-3 py-2"
          ></textarea>
        </div>
        <div>
          <label class="block font-semibold mb-1">Alt Text *</label>
          <input
            v-model="form.alt_text"
            class="w-full border rounded px-3 py-2"
          />
        </div>
      </div>
    </div>

    <label class="block font-semibold mb-1 mt-6">Content *</label>
    <div class="mb-6 border rounded">
      <TextEditorComponents v-model="form.content" />
    </div>

    <button
      @click="submit"
      class="bg-primary-400 hover:bg-primary-500 text-white font-bold py-2 px-6 rounded transition duration-200"
    >
      Update Article
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import TextEditorComponents from "@/components/Forms/TextEditorComponents"

export default {
  components: {
    TextEditorComponents
  },
  data() {
    return {
      id: this.$route.params.id,
      form: {
        title: "",
        short_desc: "",
        banner: null,
        banner_file: null,
        meta_keyword: "",
        meta_desc: "",
        alt_text: "",
        status: "Inactive",
        content: ""
      }
    }
  },
  computed: {
    ...mapGetters("article", ["article"])
  },
  async created() {
    await this.loadArticle()
  },
  methods: {
    ...mapActions("article", ["getArticle", "updateArticle"]),
    ...mapActions("common", ["showLoading", "hideLoading"]),

    async loadArticle() {
      this.showLoading()
      try {
        await this.getArticle({ id: this.id })
        if (this.article) {
          this.form = {
            ...this.form,
            title: this.article.title,
            short_desc: this.article.short_desc,
            meta_keyword: this.article.meta_keyword,
            meta_desc: this.article.meta_desc,
            alt_text: this.article.alt_text,
            content: this.article.content,
            status: this.article.status,
            banner: this.article.banner_url
          }
        }
      } finally {
        this.hideLoading()
      }
    },

    uploadBanner(e) {
      const file = e.target.files[0]
      if (!file) return
      this.form.banner = URL.createObjectURL(file)
      this.form.banner_file = file
    },

    async submit() {
      this.showLoading()
      try {
        const formData = new FormData()
        formData.append("title", this.form.title)
        formData.append("short_desc", this.form.short_desc)
        formData.append("meta_keyword", this.form.meta_keyword)
        formData.append("meta_desc", this.form.meta_desc)
        formData.append("alt_text", this.form.alt_text)
        formData.append("status", this.form.status)
        formData.append("content", this.form.content)
        if (this.form.banner_file)
          formData.append("banner", this.form.banner_file)
        formData.append("_method", "PUT")
        await this.updateArticle({ id: this.id, payloads: formData })
        this.$router.push("/article")
      } catch {
        alert("Failed to update")
      } finally {
        this.hideLoading()
      }
    }
  }
}
</script>
